import { Component, OnInit, OnDestroy, OnChanges, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { ReportsHelpbuttonService } from 'src/app/services/helpbutton-services/reports-helpbutton-service/reports-helpbutton.service';
import { DateUnixTransformerPipe } from 'src/app/pipes/date-unix-transformer-pipe/date-unix-transformer.pipe';
import { Json2csvService } from 'csvtools-lib';

@Component({
  selector: 'app-helpbutton-reports-breadcrumb-card',
  templateUrl: './helpbutton-reports-breadcrumb-card.component.html',
  styleUrls: ['./helpbutton-reports-breadcrumb-card.component.scss']
})
export class HelpbuttonReportsBreadcrumbCardComponent implements OnInit, OnDestroy, OnChanges {

  csvData;
  refreshFormattedAssistancesListSubscription: Subscription;

  constructor(private json2csv: Json2csvService,
    private reportsService: ReportsHelpbuttonService,
    private cd: ChangeDetectorRef,
    private unixtransformer: DateUnixTransformerPipe) { }

  ngOnInit() {
    this.refreshFormattedAssistancesListSubscription = this.reportsService.refreshFormattedAssistancesListListen().subscribe(
      (res) => {
        this.csvData = res;
      },
      (error) => {
      }
    );
  }

  ngOnChanges() {
  }

  public generateCSV() {
    this.csvData.map(
      (value) => {
        value['creationDate'] = this.formatDate(value['creationDate']);
        value['endDate'] = this.formatDate(value['endDate']);
        value['inSituDate'] = this.formatDate(value['inSituDate']);
        value['section'] = value['sectionDto']['sectionName'];
        value['center'] = value['sectionDto']['centerDto']['centerName'];
      }
    );

    this.json2csv.setBody(this.csvData, ['assistanceEmployeeName', 'assistanceRoomName', 'assistanceType', 'creationDate', 'customerComments', 'customerEvaluation', 'customerName', 'endDate', 'requestStatus', 'staffComments', 'timeUntilAcceptance', 'totalAssistanceTime', 'section', 'center']);
    this.json2csv.setHeader(['Employee name', 'Room', 'Type', 'Creation date', 'Customer comments', 'Customer evaluation', 'Customer name', 'End date', 'Request status', 'Staff comments', 'Time until acceptance', 'Total assistance time', 'Department', 'Center']);
    this.json2csv.generateCSV('assistances-report');
  }

  public formatDate(unixDate) {
    return this.unixtransformer.transform(unixDate);
  }

  ngOnDestroy() {
    if (this.refreshFormattedAssistancesListSubscription) { this.refreshFormattedAssistancesListSubscription.unsubscribe(); }
  }

}
